import LazyLoad from 'vanilla-lazyload';
import {gsap, Power1} from 'gsap';

/* eslint-disable*/
export default {
  init() {
    const btnLoadMore = document.getElementById('btn-load-more'),
      eventsLoader = document.getElementById('events-loader'),
      eventsFooter = document.querySelector('.events-footer'),
      urlParams = new URLSearchParams(document.location.search.substring(1)),
      paramsAjax = ['current_page'];

    let eventsItems = null;
    let activeItemDesc = null;
    let activeButtonDesc = null;
    let currentEventDescActive = null;
    let lazyLoadInstance;
    let ajaxEventsRequestCanBeLoaded = true;
    let isInitialized = false;
    let paramURLCurrentPage = urlParams.get('current_page');

    const resetFormPost = () => {
      window.events_loadmore_params.current_page = 1;
    }

    const loadEvents = () => {
      if (btnLoadMore && ajaxEventsRequestCanBeLoaded) {
        const defaultButtonText = btnLoadMore.innerHTML;
        gsap.to(eventsFooter, {opacity: 1, duration: 1, ease: Power1.easeOut});

        $.ajax({
          url: window.events_loadmore_params.ajax_url, // AJAX handler
          data: {
            'action': 'eventsloadmore', // the parameter for admin-ajax.php
            'query': window.events_loadmore_params.posts, // loop parameters passed by wp_localize_script()
            'current_page': window.events_loadmore_params.current_page, // current page
            'editions': window.events_loadmore_params.editions,
          },
          type: 'POST',
          beforeSend: function (xhr) {
            gsap.to(eventsFooter, {opacity: 0, duration: 0.5, ease: Power1.easeOut});
            btnLoadMore.innerText = 'Chargement ...';
            eventsLoader.classList.remove('d-none');
            eventsLoader.classList.add('d-flex');
            ajaxEventsRequestCanBeLoaded = false;
          },
          error: function (err) {
            console.error(err);
          },
          success: function (posts) {
            btnLoadMore.innerHTML = defaultButtonText;
            eventsLoader.classList.remove('d-flex');
            eventsLoader.classList.add('d-none');
            isInitialized = true;

            if (posts) {
              updateParamsUrl();

              let areaMoreEvents = document.getElementById('more-events');
              let areaRow = areaMoreEvents.querySelector('.row');
              areaRow.innerHTML += posts;

              gsap.fromTo(document.querySelectorAll('.item-event:not(.animated)'), {
                opacity: 0,
                yPercent: 10
              }, {
                opacity: 1,
                yPercent: 0,
                duration: 1,
                stagger: function (index, target, list) {
                  target.classList.add('animated');
                  return index * 0.3;
                }
              });

              window.events_loadmore_params.current_page++;
              ajaxEventsRequestCanBeLoaded = true;

              // Update lazy loading
              lazyLoadInstance.update();

              gsap.to(eventsFooter, {opacity: 1, duration: 0.75, ease: Power1.easeIn, delay: 1});

            } else {
              gsap.to(eventsFooter, {opacity: 0, duration: 0.75, ease: Power1.easeIn});
            }

            checkMorePostsAvailable();
            bindEventsListener();
          },
          timeout: 20000
        });
      }
    }

    const checkMorePostsAvailable = () => {
      if (parseInt(window.events_loadmore_params.current_page) > parseInt(window.events_loadmore_params.max_page)) {
        disableButtonLoadMore();
      } else {
        gsap.to(eventsFooter, {display: 'block', duration: 1})
      }
    }

    const disableButtonLoadMore = () => {
      gsap.to(eventsFooter, {display: 'none', duration: 1});
    }

    const initListeners = () => {
      if (btnLoadMore) {
        btnLoadMore.addEventListener('click', (e) => {
          e.preventDefault();
          loadEvents();
        });
      }

      if (!isInitialized && paramURLCurrentPage !== '1') {
        setCurrentPageParamUrl(1, () => {
          btnLoadMore.click()
        });
        return;
      }

      btnLoadMore.click();
    }

    const setCurrentPageParamUrl = (value, callback = null) => {
      window.events_loadmore_params.current_page = value;
      updateParamsUrl();
      if (callback) {
        callback();
      }
    }

    const updateParamsUrl = (callback = null) => {
      let args = [];

      paramsAjax.map((param) => {
        let ajaxParam = window.events_loadmore_params[param];
        if (typeof ajaxParam !== 'undefined' && ajaxParam !== '' && ajaxParam !== 'previous' && ajaxParam !== 'latest') {
          args.push(`${param}=${ajaxParam}`);
        }
      });

      if (args.length !== 0) {
        let params = args.join('&');
        let baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
        let refresh;

        if (!baseUrl.includes('?')) {
          refresh = baseUrl + '?' + params;
        } else {
          refresh = baseUrl + params;
        }

        window.history.pushState({path: refresh}, '', refresh);
      }

      paramURLCurrentPage = window.events_loadmore_params['current_page'];

      if (callback) {
        callback();
      }
    }

    /**
     * Lazy Loading images
     */
    const initLazy = () => {
      let callback_loaded = function (element) {
        element.classList.remove('is-loading');
      };
      let callback_error = function (element) {
        element.src =
          'https://via.placeholder.com/440x560/?text=Error+Placeholder';
      };

      lazyLoadInstance = new LazyLoad({
        callback_loaded: callback_loaded,
        callback_error: callback_error,
      });
      lazyLoadInstance.update();
    }

    const bindEventsListener = () => {
      eventsItems = document.querySelectorAll('.item-event');
      eventsItems.forEach((item) => {
          const toggleBtn = item.querySelector('.toggle-readmore');
          if (toggleBtn !== null) {
            toggleBtn.addEventListener('click', (e) => {
              e.preventDefault();
              const currentEventID = toggleBtn.dataset.event;
              // If another item is already active
              if (currentEventDescActive !== currentEventID && currentEventDescActive !== null) {
                closeActiveEventDesc();
              }
              // Set the current item as active
              currentEventDescActive = currentEventID;
              const parentEl = toggleBtn.parentNode.parentNode;
              parentEl.classList.toggle('is-opened');
              activeItemDesc = parentEl;
              toggleBtn.classList.toggle('is-active');
              activeButtonDesc = toggleBtn;
            });
          }
        }
      )
    }

    const closeActiveEventDesc = () => {
      activeItemDesc.classList.remove('is-opened');
      activeButtonDesc.classList.remove('is-active');
    }

    initListeners();
    initLazy();
    return true;
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/components/eventsList.js